import React, { PropTypes } from 'react';
import B from 'bem-cn';
import './index.scss';
import getStaticContent from '../../utils/getStaticContent';

const cl = B('News');

export default class News extends React.Component {
  static propTypes = {
    passRef: React.PropTypes.func,
    currentPageName: PropTypes.string.isRequired
  };

  constructor(props) {
    super(props);

    this.staticContent = getStaticContent('news', props.currentPageName);
  }

  shouldComponentUpdate() {
    return false;
  }

  render() {
    return (
      <div className={cl} id="news" ref={this.props.passRef}>
        <div className="container">
          <div className={cl('title')}>{this.staticContent.title}</div>
          <div
            dangerouslySetInnerHTML={{ __html: this.staticContent.content }}
          />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ../src/components/news/index.jsx